import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import '../assets/styles/JoinPage.css'; // Import the common styles
import { createEmployer } from '../api/api';

const EmployerForm = () => {
  const [formData, setFormData] = useState({
    companyName: '',
    description: '',
    phoneNumber: '',
    emailaddress: '',
    location: '',
  });

  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true); // Disable submit button
    setError(null);
    try {
      const data = await createEmployer(formData); // Use the API function
      setResponse('Your Profile has been Created');
      setFormData({
        companyName: '',
        description: '',
        phoneNumber: '',
        emailaddress: '',
        location: '',
      }); // Clear form data
    } catch (error) {
      console.error('Submission Error:', error.message);
      setError(error.message || 'An error occurred. Please try again.');
    } finally {
      setIsSubmitting(false); // Enable submit button
    }
  };

  return (
    <Form className="employer-form" onSubmit={handleSubmit}>
      <h2>Create Employer Profile</h2>
      {response && <p className="success-message">{response}</p>}
      {error && <p className="error-message">{error}</p>}
      <Form.Group>
        <Form.Label>Name</Form.Label>
        <Form.Control
          type="text"
          id="companyName"
          name="companyName"
          value={formData.companyName}
          onChange={handleChange}
          required
          disabled={isSubmitting}
          placeholder="Enter name"
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Email</Form.Label>
        <Form.Control
          type="email"
          id="emailaddress"
          name="emailaddress"
          value={formData.emailaddress}
          onChange={handleChange}
          required
          disabled={isSubmitting}
          placeholder="Enter email"
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Phone Number</Form.Label>
        <Form.Control
          type="text"
          id="phoneNumber"
          name="phoneNumber"
          value={formData.phoneNumber}
          onChange={handleChange}
          required
          disabled={isSubmitting}
          placeholder="Enter phone number"
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Location</Form.Label>
        <Form.Control
          type="text"
          id="location"
          name="location"
          value={formData.location}
          onChange={handleChange}
          required
          disabled={isSubmitting}
          placeholder="Enter location"
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Company Description</Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          id="description"
          name="description"
          value={formData.description}
          onChange={handleChange}
          disabled={isSubmitting}
          placeholder="Enter company description"
        />
      </Form.Group>
      <Button
        variant="primary"
        type="submit"
        className="submit-button"
        disabled={isSubmitting}
      >
        {isSubmitting ? 'Submitting...' : 'Create Profile'}
      </Button>
    </Form>
  );
};

export default EmployerForm;
